// extracted by mini-css-extract-plugin
export var readonly = "_gw-1";
export var star = "_gw-0";